const parseTimeToSeconds = timeString => {
    let days = 0,
        hours = 0,
        minutes = 0,
        seconds = 0;

    const daysMatch = timeString.match(/(\d{1,9})d/);
    if (daysMatch) days = Number.parseInt(daysMatch[1], 10);

    const hoursMatch = timeString.match(/(\d{1,9})h/);
    if (hoursMatch) hours = Number.parseInt(hoursMatch[1], 10);

    const minutesMatch = timeString.match(/(\d{1,9})m/);
    if (minutesMatch) minutes = Number.parseInt(minutesMatch[1], 10);

    const secondsMatch = timeString.match(/(\d{1,9})s/);
    if (secondsMatch) seconds = Number.parseInt(secondsMatch[1], 10);

    return days * 86400 + hours * 3600 + minutes * 60 + seconds;
};

export default parseTimeToSeconds;
